import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import type React from 'react';
import { Component } from 'react';
import type { ExportEntry } from '~/services/exports';

type ConfirmDeleteDialogProps = {};

interface ConfirmDeleteDialogState {
  open: boolean;
  exported?: ExportEntry;
}

export class ConfirmDeleteDialog extends Component<ConfirmDeleteDialogProps, ConfirmDeleteDialogState> {
  private internalResolve!: (value: boolean | PromiseLike<boolean>) => void;

  constructor(props: ConfirmDeleteDialogProps) {
    super(props);
    this.state = {
      open: false,
    };
  }

  openDialog = (exported: ExportEntry): Promise<boolean> => {
    this.setState({
      open: true,
      exported,
    });

    return new Promise((resolve) => {
      this.internalResolve = resolve;
    });
  };

  closeDialog = (toDelete: boolean): void => {
    this.setState({ open: false });
    this.internalResolve(toDelete);
  };

  handleClose = (): void => this.closeDialog(false);

  handleDelete = (): void => this.closeDialog(true);

  render(): React.ReactNode {
    const { open, exported } = this.state;

    return (
      <Dialog open={open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Vill du verkligen ta bort exporten {exported?.version}?</DialogTitle>
        <DialogContent>Detta är permanent och kan inte ångras.</DialogContent>
        <DialogActions>
          <Button autoFocus onClick={this.handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleDelete} variant="contained" color="primary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
